import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordModalComponent } from './users/user-change-password-modal/change-password-modal.component';
import { NewPasswordUser } from 'src/models/newPasswordUser.interface';
import { AuthService } from 'src/auth/auth.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { HomeService } from './home.service';
import { SidebarService } from './sidebar.service'; // Asegúrate de importar el SidebarService
import { Subject } from 'rxjs';
import { UsersService } from './users/services/users.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  isSidebarActive: boolean = false;
  isBillingSubMenuOpen: boolean = false;
  isCrmSubMenuOpen: boolean = false;
  isProviderSubMenuOpen: boolean = false;
  isOpened = false;
  userInfo: any;
  userRole: string = '';

  public rolesMap: any = {
    ROLE_CONSULTANT: 'Consultor',
    ROLE_ADMIN: 'Administrador',
    ROLE_CRM: 'Usuario de CRM',
  };

  public isLoading: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private homeService: HomeService,
    private usersService: UsersService,
    private authService: AuthService,
    private router: Router,
    public sidebarService: SidebarService
  ) { }

  ngOnInit(): void {
    // this.handleGetUserInfo();
    this.userRole = this.authService.getCurrentUserRole();

  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      // Llama al método para cerrar el menú lateral si la tecla Escape es presionada
      this.closeSidenavIfOpen();
    }
  }
  closeSidenavIfOpen() {
    // Verifica si el sidebar está abierto y, de ser así, ciérralo.
    if (this.sidebarService.isOpen.value) {
      this.sidebarService.close();
    }
  }
  formatRole(role: string): string {
    return this.rolesMap[role] || role;
  }

  isHomePage(): boolean {
    return this.router.url === '/home';
  }

  handleGetUserInfo(): void {
    this.isLoading = true;
    this.usersService.getUserInfo().subscribe(
      (data: any) => {
        this.isLoading = false;
        if (data && data.role) {
          data.role = this.formatRole(data.role);
        }
        this.userInfo = data;
      },
      (error: any) => {
        console.error('Error fetching user info:', error);
        this.isLoading = false;
      }
    );
  }

  openUserFormModal(): void {
    const dialogRef = this.dialog.open(ChangePasswordModalComponent, {
      width: '70%',
      maxWidth: '600px',
      data: {
        title: 'Usuario',
        email: this.userInfo.email
      },
    });

    dialogRef.afterClosed().subscribe((result: NewPasswordUser) => {
      if (result) {
        console.log(result);
      }
    });
  }

  handleLogout(): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: '¿Quieres cerrar sesión?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FFA500',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, cerrar sesión',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.logout();
        this.router.navigate(['/login']);
      }
    });
  }

  toggleCrmSubMenu(): void {
    this.isCrmSubMenuOpen = !this.isCrmSubMenuOpen;
  }
  toggleProviderSubMenu(): void {
    this.isProviderSubMenuOpen = !this.isProviderSubMenuOpen;
  }

  toggleBillingSubMenu(): void {
    this.isBillingSubMenuOpen = !this.isBillingSubMenuOpen;
  }

  toggleSidenav(): void {
    this.sidebarService.toggleSidebar();

    if (window.innerWidth < 768) {
      this.isSidebarActive = !this.isSidebarActive;
    }
  }
  getUserRole(): void {
    this.userRole = this.authService.getCurrentUserRole();
    console.log('UserRole:', this.userRole);
  }
  // @HostListener('window:resize', ['$event'])
  // onResize(event: Event) {
  //   this.adjustSidebarState((event.target as Window).innerWidth);
  // }

  // adjustSidebarState(width: number) {
  //   if (width < 768) {
  //     this.sidebarService.close();
  //   } else {
  //     this.sidebarService.isOpen;
  //   }
  // }

}
